import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: function() {
        return "api/companies/index.php";
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/models/companyModel.js
// module id = 19
// module chunks = 0